import { render } from "./componentImage.vue?vue&type=template&id=2393f9d4"
import script from "./componentImage.vue?vue&type=script&lang=js"
export * from "./componentImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__